import PropTypes from 'prop-types';

import Settings from './RightPanel/Settings';

const TABS = [
  {
    title: 'Notification Settings',
    key: 'notif-settings',
    component: Settings,
  },
];

export const tabType = PropTypes.shape({
  title: PropTypes.string,
  key: PropTypes.string.isRequired,
  component: PropTypes.component,
  onClick: PropTypes.func,
  TitleComponent: PropTypes.component,
});

export default TABS;
